module.exports = __webpack_public_path__ + "img/global.d13c64b.svg";